import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { configPropertyListFailure, configPropertyListSuccess } from '../../actions/configPropertyActions/configPropertyListActions';
import store from '../../configStore';

function* configPropertyList({ payload }) {
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getAllConfigProperties,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("CONFIG_PROPERTY_LIST_SUCCESS status :", response.data.status);
        console.log("CONFIG_PROPERTY_LIST_SUCCESS data :", response.data.response);
        console.log("CONFIG_PROPERTY_LIST_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            configPropertyListSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("CONFIG_PROPERTY_LIST_FAILURE status :", error?.response?.status);
        console.log("CONFIG_PROPERTY_LIST_FAILURE data:", error?.response?.data);
        console.log("CONFIG_PROPERTY_LIST_FAILURE error :", error);
        console.log('====================================');
        yield put(configPropertyListFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* configPropertyListSaga() {
    yield takeLatest(actionTypes.CONFIG_PROPERTY_LIST_REQUEST, configPropertyList);
}

export default configPropertyListSaga;
